import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import "./Addannouncement.css";

const API_URL = "https://aadyaacademy.org/api"; // Backend API URL

const Addannouncement = ({ closeForm, announcement }) => {
  const [title, setTitle] = useState(announcement ? announcement.title : "");
  const [details, setDetails] = useState(announcement ? announcement.details : "");
  const [category, setCategory] = useState(announcement ? announcement.category : "");
  const [fromDate, setFromDate] = useState(
    announcement
      ? moment(announcement.fromDate, ["YYYY-MM-DD", "MM/DD/YYYY"]).format("YYYY-MM-DD")
      : ""
  );
  const [toDate, setToDate] = useState(
    announcement
      ? moment(announcement.toDate, ["YYYY-MM-DD", "MM/DD/YYYY"]).format("YYYY-MM-DD")
      : ""
  );
  const [pdfFile, setPdfFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [pdfUrl, setPdfUrl] = useState(announcement ? announcement.attachmentUrl : null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API_URL}/categories`);
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
        toast.error("Failed to fetch categories.");
      }
    };

    if (announcement && announcement.id) {
      const fetchAnnouncementDetails = async () => {
        try {
          const response = await axios.get(
            `${API_URL}/announcements/${announcement.id}`
          );
          const data = response.data;
          setTitle(data.title);
          setDetails(data.details);
          setCategory(data.category);
          setFromDate(moment(data.fromDate, ["YYYY-MM-DD", "MM/DD/YYYY"]).format("YYYY-MM-DD"));
          setToDate(moment(data.toDate, ["YYYY-MM-DD", "MM/DD/YYYY"]).format("YYYY-MM-DD"));
          setPdfUrl(data.attachmentUrl);
        } catch (error) {
          console.error("Error fetching announcement details:", error);
          toast.error("Failed to fetch announcement details.");
        }
      };
      fetchAnnouncementDetails();
    }

    fetchCategories();
  }, [announcement]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setPdfFile(file);
    } else {
      setPdfFile(null);
      toast.error("Please upload a valid PDF file.");
    }
  };

  const handleFromDateChange = (e) => {
    const selectedFromDate = e.target.value;
    setFromDate(selectedFromDate);
    if (toDate && new Date(selectedFromDate) > new Date(toDate)) {
      toast.error("From Date cannot be after To Date.");
      setToDate("");
    }
  };

  const handleToDateChange = (e) => {
    const selectedToDate = e.target.value;
    if (fromDate && new Date(selectedToDate) < new Date(fromDate)) {
      toast.error("To Date cannot be before From Date.");
      return;
    }
    setToDate(selectedToDate);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!title || !details || !category || !fromDate || !toDate) {
      toast.error("Please fill in all required fields.");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("details", details);
    formData.append("category", category);
    formData.append("fromDate", fromDate);
    formData.append("toDate", toDate);
    if (announcement) {
      formData.append("id", announcement.id);
    }
    if (pdfFile) {
      formData.append("pdfFile", pdfFile);
    } else if (pdfUrl) {
      // Normalize pdfUrl to relative path
      const relativeUrl = pdfUrl.includes('https://')
        ? pdfUrl.replace('https://aadyaacademy.org/', '')
        : pdfUrl;
      formData.append("pdfUrl", relativeUrl);
    }

    try {
      if (announcement) {
        await axios.put(`${API_URL}/announcements`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Announcement updated successfully!");
      } else {
        await axios.post(`${API_URL}/announcements`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Announcement submitted successfully!");
      }

      setTimeout(() => {
        try {
          closeForm();
          console.log("Attempting to navigate to /announcements");
          navigate("/announcements");
        } catch (navError) {
          console.error("Navigation error:", navError);
          toast.error("Failed to navigate to announcements page.");
        }
      }, 1500);
    } catch (error) {
      console.error("Error submitting announcement:", error);
      toast.error(
        `Failed to upload announcement: ${error.response?.data?.message || error.message || "Unknown error"}`
      );
    }
  };

  return (
    <div className="add-announcement-container">
      <div className="add-anou-c">
        <h2>{announcement ? "Edit Announcement" : "Add New Announcement"}</h2>
        <form onSubmit={handleFormSubmit}>
          <div className="form-group-Title">
            <h4>Announcement Title</h4>
            <input
              type="text"
              title="title"
              placeholder="Enter"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>
          <div className="form-group-Details">
            <h4>Announcement Details</h4>
            <textarea
              title="details"
              placeholder="Enter"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              required
            />
          </div>
          <div className="form-group-btm">
            <div className="form-group-Category">
              <h4>Category</h4>
              <select
                title="category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
              >
                <option value="">Select</option>
                {categories.length > 0 ? (
                  categories.map((cat) => (
                    <option key={cat.id} value={cat.name}>
                      {cat.name}
                    </option>
                  ))
                ) : (
                  <option value="">Loading categories...</option>
                )}
              </select>
            </div>
            <div className="form-group-Date">
              <h4>From Date</h4>
              <input
                type="date"
                title="fromDate"
                value={fromDate}
                onChange={handleFromDateChange}
                required
              />
            </div>
            <div className="form-group-Date">
              <h4>To Date</h4>
              <input
                type="date"
                title="toDate"
                value={toDate}
                onChange={handleToDateChange}
                required
              />
            </div>
          </div>
          <div className="form-group-Pdf">
            <h4>Upload PDF File</h4>
            <input
              type="file"
              title="pdfFile"
              accept="application/pdf"
              onChange={handleFileChange}
            />
            {pdfFile && <p>Uploaded File: {pdfFile.name}</p>}
            {pdfUrl && !pdfFile && (
              <p>
                Existing PDF:{" "}
                <a
                  href={`${API_URL}/${pdfUrl.replace('https://aadyaacademy.org/', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </a>
              </p>
            )}
          </div>
          <div className="form-buttons">
            <button className="form-buttons-submit" type="submit">
              Submit
            </button>
            <button
              className="form-buttons-cancel"
              type="button"
              onClick={closeForm}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default Addannouncement;